export default num => {
  if (num || typeof num === 'number') {
    let pair = (`${num}e`).split('e');
    const value = Math.round(`${pair[0]}e${+pair[1] + 2}`);
    pair = (`${value}e`).split('e');
    return +(`${pair[0]}e${+pair[1] - 2}`);
  }
  return num;
};
